export const enum USAGE_IMAGES_ENUM {
  LOGIN_APP = 'LOGIN_APP',
  PUSH_APP = 'PUSH_APP',
  LOGIN = 'LOGIN',
  PUSH = 'PUSH',
}
